// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3tflF","range":"MonthRangeSwitch_range__37ep7","disabled":"MonthRangeSwitch_disabled__3444-"};